import { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import { useTranslation } from "react-i18next";

export default function NewScheduleButton() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const handleConfirm = () => {
    setOpen(false);
    navigate("/new");
  };

  return (
    <>
      <Button
        variant="contained"
        color="primary"
        onClick={handleOpen}
        startIcon={
          // Import AddIcon from @mui/icons-material at the top of your file
          // import AddIcon from "@mui/icons-material/Add";
          <AddIcon />
        }
      >
        {t("new")}
      </Button>

      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>{t("discardCurrentSchedule")}</DialogTitle>
        <DialogContent>
          <DialogContentText>{t("unsavedChangesWarning")}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="inherit">
            {t("cancel")}
          </Button>
          <Button onClick={handleConfirm} color="primary" variant="contained">
            {t("yesContinue")}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
